// Components/Items/ChangelogModal.jsx
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { message } from "antd";
import ModalItem from "../../../Components/ModalItem";
import { cambiarVersionChangeLog } from "../../../store/actions/user";
// import ButtonItem from "../../../Components/ButtonItem";

class ModalVersion extends Component {
  state = {
    loading: false,
  };

  cerrarChangelog = () => {
    this.setState({ loading: true });

    axios.post(
      "marcarChangelogComoVisto",
      {
        usuarioId: this.props.usuarioId,
        version: this.props.version,
      },
      {
        headers: this.props.headersToken,
      }
    )
      .then(() => {
        this.setState({ loading: false });
        this.props.cambiarVersionChangeLog({
          mostrarChangelog: false,
          changelogVersion: this.props.version,
        });
        this.props.onClose();
      })
      .catch((err) => {
        console.error("Error al marcar changelog como visto:", err);
        this.setState({ loading: false });
        message.error("Error al cerrar changelog.");
      });
  };

  render() {
    return (
      <ModalItem
        title={`Novedades - ${this.props.version}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarChangelog}
        width={700}
        // bottom={
        //   <ButtonItem
        //     type="primary"
        //     onClick={this.cerrarChangelog}
        //     loading={this.state.loading}
        //     style={{ display: "block", margin: "0 0 0 auto" }}
        //   >
        //     Entendido
        //   </ButtonItem>
        // }
      >
        {/* La lista creció a cinco secciones: el contenido scrollea DENTRO del modal en vez de
            estirarlo hacia abajo, que dejaba la X de cerrar fuera de la pantalla. */}
        <div style={{ maxHeight: "65vh", overflowY: "auto", paddingRight: 10 }}>
        <p style={{marginTop: 10}}>📅 <strong>Actualización del 5 de septiembre de 2026</strong></p>
        <p>
          Realizamos una nueva actualización en el sistema BIWO. Estas son las novedades que ya
          puedes usar, agrupadas por módulo:
        </p>

        <p style={{ marginBottom: 4 }}>👥 <strong>Nómina y Finiquitos</strong></p>
        <ul style={{ paddingLeft: 20 }}>
          <li>✏️ <strong>El finiquito se sigue ajustando después de aplicarlo:</strong> los días, los importes y los conceptos quedan editables hasta que se timbra, y cada cambio se guarda solo. Desde el desglose también puedes agregar o quitar conceptos, igual que en el sobre-recibo. Ya no hay que deshacer y recapturar todo por un retoque.</li>
          <li>📆 <strong>Fecha de pago del finiquito:</strong> captura el día en que realmente pagas la liquidación. Es la que llevan su póliza contable y su CFDI. Si la dejas vacía se usa la de la prenómina, como hasta ahora.</li>
          <li>📗 <strong>Cada finiquito tiene su propia póliza:</strong> se contabiliza aparte de la nómina del periodo, con su fecha de pago. Al cancelar el timbrado esa póliza se cancela completa, y al volver a timbrar se genera una nueva.</li>
          <li>🧾 <strong>Recibo y cancelación sin salir del finiquito:</strong> ve el PDF, descarga el XML y cancela el timbrado desde la misma pantalla. Cuando la liquidación se emite en dos CFDI (el ordinario y el de indemnización o separación) puedes elegir cuál ver, y se descargan los dos XML.</li>
          <li>📄 <strong>Carta de finiquito más completa:</strong> ahora identifica al trabajador con RFC, CURP, NSS y puesto, trae las fechas de ingreso y baja con la antigüedad, y muestra los días pagados de cada percepción.</li>
          <li>🧭 <strong>Guía "Cómo hacerlo" dentro del finiquito:</strong> los pasos del proceso y las dudas de siempre — por qué salieron dos recibos, por qué un concepto paga 0.00 y cómo corregir según qué tan lejos hayas llegado.</li>
          <li>📊 <strong>Los finiquitos ya no se revuelven con la nómina:</strong> en la prenómina salen en su propia tabla, con sus totales aparte y el total real del periodo. La Lista de Raya se descarga en tres versiones: ordinaria (sin finiquitos), completa o sólo finiquitos, y el mismo filtro está en Reportes de Nómina y en el Comparativo de Periodos.</li>
          <li>⚖️ <strong>Guía Legal de Conceptos:</strong> busca cualquier concepto y te dice qué es según la Ley Federal del Trabajo, qué grava y qué exenta de ISR e IMSS, y con qué fórmulas darlo de alta. Puedes aplicar la ficha directamente al concepto que estás capturando.</li>
          <li>🔍 <strong>Fórmulas que ya no fallan en silencio:</strong> si una fórmula menciona un concepto que no le aplica al empleado, ese dato vale cero y el resto se sigue calculando en lugar de dejar el concepto entero en 0.00. Con doble clic en el nombre del concepto ves cuáles valieron cero y por qué. Además hay nuevas variables de calendario (mes, ejercicio, inicio y fin de bimestre IMSS, y más).</li>
          <li>0️⃣ <strong>Recibos en ceros:</strong> un recibo sin percepciones ya no se manda al SAT ni se reporta como error. Queda marcado como "Sin timbre" y la nómina se puede cerrar normalmente.</li>
        </ul>

        <p style={{ marginBottom: 4 }}>📚 <strong>Contabilidad y Pólizas</strong></p>
        <ul style={{ paddingLeft: 20 }}>
          <li>🔗 <strong>Ver Pólizas de un documento:</strong> desde una venta, una orden de compra o una factura, imprime en una sola hoja todas las pólizas de su ciclo de vida — la entrada de mercancía, la factura, sus pagos y sus notas de crédito—, con la opción de verlas detalladas.</li>
          <li>⚡ <strong>Ver la póliza al terminar un movimiento:</strong> nueva configuración que abre sola la hoja con las pólizas que acaba de generar la operación, sin tener que entrar al documento a buscarlas. Se activa por empresa y por permiso de usuario.</li>
          <li>💱 <strong>Tipo de cambio en la póliza:</strong> los renglones de operaciones en otra moneda muestran su tipo de cambio junto al concepto.</li>
          <li>✉️ <strong>Avisos de póliza descuadrada más claros:</strong> el correo de alerta ahora dice de qué empresa y de qué póliza se trata, con su concepto, su fecha y el motivo por el que no se pudo balancear.</li>
        </ul>

        <p style={{ marginBottom: 4 }}>🛒 <strong>Compras y Facturas de Proveedor</strong></p>
        <ul style={{ paddingLeft: 20 }}>
          <li>❓ <strong>"¿Por qué no cuadra?":</strong> cuando el total capturado no coincide con el del XML, un botón compara los dos lados y te dice exactamente de dónde sale la diferencia — el subtotal, un impuesto, una retención o un renglón con otra tasa—, con el detalle concepto por concepto. Desde ahí mismo aplicas el ajuste automático. Está en factura sin orden de compra, caja chica, recibir factura, recepción múltiple, nota de crédito y devolución de compra.</li>
          <li>🏦 <strong>Paquetes de comisión bancaria:</strong> configura la comisión y su IVA como un paquete del banco, y al pagar una factura eliges qué paquetes aplicar. Antes era todo o nada.</li>
          <li>📎 <strong>Archivos del proveedor desde el alta:</strong> ya puedes adjuntarlos al crear el proveedor y no sólo al editarlo.</li>
          <li>📋 <strong>Cotizaciones de requisición:</strong> si la requisición trae el mismo insumo en varias líneas, se juntan en un solo renglón con la cantidad sumada, para que al proveedor le llegue la cantidad completa.</li>
        </ul>

        <p style={{ marginBottom: 4 }}>💼 <strong>Ventas y Cotizaciones</strong></p>
        <ul style={{ paddingLeft: 20 }}>
          <li>💲 <strong>Recotizar una cotización ya convertida:</strong> ahora se puede cambiar el precio unitario de sus insumos. Las cantidades, los descuentos y los insumos siguen bloqueados, y el cambio no afecta a la venta o el pedido que ya se generó.</li>
          <li>🔢 <strong>Series personalizadas:</strong> el selector de serie muestra el siguiente folio que se va a usar, y quién puede elegir serie y folio se controla con un permiso propio.</li>
        </ul>

        <p style={{ marginBottom: 4 }}>📈 <strong>Reportes</strong></p>
        <ul style={{ paddingLeft: 20 }}>
          <li>🆕 <strong>Costo Vs Última Compra:</strong> compara el costo del catálogo contra lo que costó la última compra de cada insumo, con semáforo de desviación, filtros por periodo, proyecto y desviación mínima, y descarga en Excel y PDF. Sirve para cazar los costos que se quedaron viejos.</li>
          <li>📊 <strong>Excel de totales de Cuentas por Cobrar:</strong> el resumen por cliente del reporte de CxC —normal y agrupado— ya se puede descargar en Excel, separado por moneda y con el mismo encabezado y logo del PDF.</li>
        </ul>

        <p>Si tienes alguna duda o necesitas asistencia, nuestro equipo de soporte está disponible para ayudarte.</p>
        <p><strong>¡Gracias por confiar en BIWO!</strong></p>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps, {cambiarVersionChangeLog})(ModalVersion);
